import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query codigoActividad {
            TYPES {
              CodigoActividad {
                readAll {
                  id
                  value
                  annotation
                  old
                }
              }
            }
          }
        `,
      })
      .then((result) => result.data.data.TYPES.CodigoActividad.readAll),
};
